import { Col, Container, Row } from "react-bootstrap";

import CartaElemento from "./CartaElemento";
import React from 'react';

import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, } from 'chart.js';
import { Line } from 'react-chartjs-2';
import PaginaNonTrovata from "../../Utente/Error/PaginaNonTrovata";
import statisticheServiceInstance from "../../../services/StatisticheService";
import { useEffect, useState } from "react";

// Import icone
import petizioni_icon from '../../../immagini/icone_sidebar/petizioni.png'
import referendum_icon from '../../../immagini/icone_sidebar/referendum.png'
import bp_icon from '../../../immagini/icone_sidebar/bilancio_partecipativo.png'
import { iniziative_white as iniziative_icon } from '../../../utilities/icone'
import segnalazioni_icon from '../../../immagini/icone_sidebar/segnalazioni.png'
import sondaggio_icon from '../../../immagini/icone_sidebar/sondaggio.png'

// Registrazione componenti di Chart.js
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);


export default function Cruscotto({ comune, partecipante }) {

    //Stato per le statistiche
    const [statistiche, setStatistiche] = useState(null);
    const [chartData, setChartData] = useState(null);
    const [loading, setLoading] = useState(true); 
    const [error, setError] = useState(null); 

    // Opzioni per il grafico
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: "top" },
            title: { display: false, text: "Attività mensile degli utenti" },
            datalabels: {
                display: false // Disabilita le etichette sopra i punti
            }
        },
        scales: { 
            y: { // Configurazione per l'asse Y (verticale)
                beginAtZero: true, // Forza l'asse a partire da 0
                ticks: {
                    stepSize: 1,
                }
            }
        }
    };
    /**
 * Genera i dati per il grafico aggregando i conteggi mensili.
 * @param {Object} statistiche - Dati delle statistiche recuperati dal backend.
 */
    const generaDatiGrafico = (stats) => {

        
        const now = new Date();
        const mesi = [];
        const labels = [];
    
        // Crea array degli ultimi 12 mesi
        for (let i = 11; i >= 0; i--) {
            const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
            mesi.push({ anno: d.getFullYear(), mese: d.getMonth() }); // mese: 0-11
            labels.push(d.toLocaleString("it-IT", { month: "short", year: "2-digit" }));
        }
    
        // Funzione per contare le date per mese/anno negli ultimi 12 mesi
        const contaPerMese = (dates) => {
            const conteggio = Array(12).fill(0);
            if (!Array.isArray(dates)) {
                console.warn("Input 'dates' non è un array:", dates);
                return conteggio; // Return array of zeros if dates is not valid
            }
            dates.forEach(dateStr => {
                if (dateStr) {
                    try {
                        const d = new Date(dateStr);
                        if (isNaN(d.getTime())) { // Check for invalid date
                           // console.warn(`Data non valida trovata: ${dateStr}`);
                            return; // Skip invalid date string
                        }
                        // Find the index corresponding to the date's month/year in our 'mesi' array
                        const index = mesi.findIndex(m => d.getFullYear() === m.anno && d.getMonth() === m.mese);
                        if (index !== -1) {
                            conteggio[index]++;
                        }
                    } catch (e) {
                        console.error(`Errore durante il parsing della data: ${dateStr}`, e);
                    }
                }
            });
            return conteggio;
        };

        const datasets = [];
    
        if (comune.impostazioniComune.imcModuloPetizioniAttivo && stats.petizioni) {
            datasets.push({
                label: "Petizioni",
                data: contaPerMese(stats.petizioni.dates),
                borderColor: "rgb(255, 99, 132)",
                backgroundColor: "rgba(255, 99, 132, 0.5)",
                tension: 0.1 // Optional: makes lines slightly curved
            });
        }
        if (comune.impostazioniComune.imcModuloReferendumAttivo && stats.referendum) {
            datasets.push({
                label: "Referendum",
                data: contaPerMese(stats.referendum.dates),
                borderColor: "rgb(53, 162, 235)",
                backgroundColor: "rgba(53, 162, 235, 0.5)",
                tension: 0.1
            });
        }
        if (comune.impostazioniComune.imcModuloBilanciAttivo && stats.bilanci) {
            datasets.push({
                label: comune.impostazioniComune.imcLabelModuloBilanci || "Bilanci", // Use custom label if available
                data: contaPerMese(stats.bilanci.dates),
                borderColor: "rgb(0, 99, 41)",
                backgroundColor: "rgba(0, 99, 41, 0.5)",
                tension: 0.1
            });
        }
        if (comune.impostazioniComune.imcModuloSegnalazioniAttivo && stats.segnalazioni) {
            datasets.push({
                label: "Segnalazioni",
                data: contaPerMese(stats.segnalazioni.dates),
                borderColor: "rgb(255, 165, 0)",
                backgroundColor: "rgba(255, 165, 0, 0.5)",
                tension: 0.1
            });
        }
        if (comune.impostazioniComune.imcModuloIniziativeAttivo && stats.iniziative) {
            datasets.push({
                label: comune.impostazioniComune.imcLabelModuloIniziative || "Iniziative", // Use custom label
                data: contaPerMese(stats.iniziative.dates),
                borderColor: "rgb(153, 102, 255)",
                backgroundColor: "rgba(153, 102, 255, 0.5)",
                tension: 0.1
            });
        }
        if (comune.impostazioniComune.imcModuloSondaggiAttivo && stats.sondaggi) {
            datasets.push({
                label: comune.impostazioniComune.imcLabelModuloSondaggi || "Sondaggi", // Use custom label
                data: contaPerMese(stats.sondaggi.dates),
                borderColor: "rgb(255, 206, 86)",
                backgroundColor: "rgba(255, 206, 86, 0.5)",
                tension: 0.1
            });
        }

        // Only set chart data if there's at least one active module with data
        if (datasets.length > 0) {
             setChartData({ labels, datasets });
        } else {
             setChartData(null); // Set to null if no datasets are generated
             console.log("Nessun modulo attivo o dati disponibili per il grafico.");
        }
    };
    
    useEffect(() => {
        if (comune.comId) {
            statisticheServiceInstance.getStatistiche(comune.comId)
                .then(res => {
                    console.log("Dati ricevuti:", res.data); // DEBUG: verifica i dati nel console log
                    setStatistiche(res.data);
                    generaDatiGrafico(res.data);
                })
                .catch(err => {
                    console.error("Errore nel recupero delle statistiche:", err);
                    setStatistiche(null);
                });
        }
    }, [comune]);
 

    if (partecipante.parId && partecipante.ruolo.ruoFlAmministratore && comune.impostazioniComune) {
        return (
            <Container>
                <h1 className="title">Cruscotto</h1>

                <Row className="d-flex justify-content-between">
                {comune.impostazioniComune.imcModuloPetizioniAttivo && (
                        <Col className="mt-2">
                            <CartaElemento
                                titolo="Petizioni"
                                parolaElementi="Petizioni"
                                numero={statistiche?.petizioni.count || 0}
                                icona={petizioni_icon}
                                parolaBottone="e le petizioni"
                                path="/admin/petizioni"
                            />
                        </Col>
                    )}
                    {comune.impostazioniComune.imcModuloReferendumAttivo && (
                        <Col className="mt-2">
                            <CartaElemento
                                titolo="Referendum"
                                parolaElementi="Referendum"
                                numero={statistiche?.referendum.count || 0}
                                icona={referendum_icon}
                                parolaBottone="i i referendum"
                                path="/admin/referendum"
                            />
                        </Col>
                    )}
                    {comune.impostazioniComune.imcModuloBilanciAttivo && (
                        <Col className="mt-2">
                            <CartaElemento
                                titolo={comune.impostazioniComune.imcLabelModuloBilanci}
                                parolaElementi={comune.impostazioniComune.imcLabelModuloBilanci}
                                numero={statistiche?.bilanci.count || 0}
                                icona={bp_icon}
                                parolaBottone="e i bilanci"
                                path="/admin/bilanci-partecipativi"
                            />
                        </Col>
                    )}
                    {comune.impostazioniComune.imcModuloSegnalazioniAttivo && (
                        <Col className="mt-2">
                            <CartaElemento
                                titolo="Segnalazioni"
                                parolaElementi="Segnalazioni"
                                numero={statistiche?.segnalazioni.count || 0}
                                icona={segnalazioni_icon}
                                parolaBottone="e le segnalazioni"
                                path="/admin/segnalazioni"
                            />
                        </Col>
                    )}
                    {comune.impostazioniComune.imcModuloIniziativeAttivo && (
                        <Col className="mt-2">
                            <CartaElemento
                                titolo={comune.impostazioniComune.imcLabelModuloIniziative}
                                parolaElementi={comune.impostazioniComune.imcLabelModuloIniziative}
                                numero={statistiche?.iniziative.count || 0}
                                icona={iniziative_icon}
                                parolaBottone="e le iniziative"
                                path="/admin/iniziative"
                            />
                        </Col>
                    )}
                    {comune.impostazioniComune.imcModuloSondaggiAttivo && (
                        <Col className="mt-2">
                            <CartaElemento
                                titolo={comune.impostazioniComune.imcLabelModuloSondaggi}
                                parolaElementi={comune.impostazioniComune.imcLabelModuloSondaggi}
                                numero={statistiche?.sondaggi.count || 0}
                                icona={sondaggio_icon}
                                parolaBottone="e i sondaggi"
                                path="/admin/sondaggi"
                            />
                        </Col>
                    )}
                </Row>

                <Row className="mt-5 d-none d-md-block">
                    {chartData && <Line options={options} data={chartData} height="70vh" />}
                </Row>
            </Container>
        );
    } else {
        return <PaginaNonTrovata />;
    }
}